import React, { Component } from "react";
import { getStaticText } from '../../../lables/lablesService';
import Spinner from '../../../components/spinner-component/Spinner';
import TransportationToOrderCategories from '../api/transportationToOrderCategories';
import CategoryForm from './categoryForm';
import CategoriesList from './categoriesList';
import Popup from "reactjs-popup";

import 'reactjs-popup/dist/index.css';
import '../../../scss/os-global.scss';


class TransportationToOrderCategoriesPage extends Component {

    constructor(props) {
        super(props);

        this.categories = [];
        this.page = 1;
        this.per_page = 10;
        this.all_pages = 0;
        this.order = {'position' : "ASC"};

        this.save_type_process = false;
        this.category_info = {};
        this.empty_category_info = {
            'id' : 0,
            'image' : '',
            'image_name' : '',
            'name' : '',
            'description' : '',
            'active' : 1,
            'position' : 99999
        };

        this.state = {
            'has_data' : false,
            'show_popup' : false
        };
    }


    /*====================================================================================*/
    /*====================================================================================*/
    /*====================================================================================*/
    async changePage (page_number = 1) {
        this.page = page_number;
        await this.getDataList();
    }


    async changeOrder (new_order = {}) {
        this.order = new_order;
        await this.getDataList();
    }


    async formCallback () {
        this.page = 1;
        this.popupToggle();
        await this.getDataList();
    }


    openAddNewForm () {
        Object.assign(
            this.category_info,
            this.empty_category_info
        );
        this.popupToggle();
    }


    openEditForm ( row_for_edit = {} ) {
        Object.assign(
            this.category_info,
            row_for_edit,
            {
                'image' : TransportationToOrderCategories.getImageUrl( row_for_edit.image )
            }
        );
        this.popupToggle();
    }


    popupToggle () {
        this.setState({
            'show_popup' : !this.state.show_popup
        });
    }
    /*====================================================================================*/
    /*====================================================================================*/
    /*====================================================================================*/


    async deletePost ( post_for_delete ) {
        if ( !window.confirm(getStaticText('remove_confirm_text')) )
            return false;

        let result = await TransportationToOrderCategories.remove( post_for_delete.id );
        if ( !result ) {
            window.alert( getStaticText('remove_error') );
        } else {
            window.alert( getStaticText('remove_success') );
            this.page = 1;
            this.getDataList();
        }
    }


    async getDataList () {
        this.setState({'has_data' : false});

        let list_response = await TransportationToOrderCategories.list({
                                                    'page' : this.page,
                                                    'per_page' : this.per_page,
                                                    'order' : this.order
                                                });
        if ( typeof(list_response.rows) !== 'undefined' ) {
            this.categories = list_response.rows;
            this.all_pages = list_response.all_pages;
        }

        this.setState({'has_data' : true});
    }


    async componentDidMount () {
        await this.getDataList();
    }


    render () {
        let content = null;
        if ( !this.state.has_data ) {
            content = (<div className="col-lg-12 text-center">{<Spinner />}</div>);
        } else {
            content = (<>
                <div className="col-lg-12 os-text-right">
                    <button 
                        onClick={this.openAddNewForm.bind(this)}
                        className="btn btn-success text-white"
                    >
                        {getStaticText('ttoc_add_new_button_label')}
                    </button>
                </div>

                <Popup
                    open={this.state.show_popup}
                    closeOnDocumentClick={false}
                    closeOnEscape={false}
                    className="os-popup"
                >
                    <>
                        <div className="os-popup-header">
                            <span className="op-popup-title">
                                {this.category_info.id ? getStaticText('ttoc_edit_popup_title') : getStaticText('ttoc_add_new_popup_title')}
                            </span>
                            <button
                                onClick={this.popupToggle.bind(this)}
                                className="os-popup-close-button"
                            >
                                <i className="fa fa-times" />
                            </button>
                        </div>

                        <div className="os-popup-body">
                            <CategoryForm
                                info={this.category_info}
                                formCallback={this.formCallback.bind(this)}
                            />
                        </div>
                    </>
                </Popup>

                <CategoriesList 
                    posts={this.categories}
                    page={this.page}
                    all_pages={this.all_pages}
                    order={this.order}
                    changeOrder={this.changeOrder.bind(this)}
                    changePage={this.changePage.bind(this)}
                    editFunction={this.openEditForm.bind(this)}
                    deleteFunction={this.deletePost.bind(this)}
                />

            </>);
        }
        return (<div className="row">
                    <div className="col-lg-12">
                        <h2>{getStaticText('ttoc_section_title')}</h2>
                    </div>
                    {content}
                </div>);
    }

}


export default TransportationToOrderCategoriesPage;